import "./tools.css";

type toolItem = {
  title: string;
  description: string;
  image: string;
  link: string;
  software: string[];
};

const tools: toolItem[] = [
  {
    title: "🗡️Katana - Slice Manga Pages!",
    description:
      "Katana is a tool that allows you to slice manga pages into individual panels. Katana integrates directly into Photoshop, click the links below to download and learn more!",
    image: "https://i.imgur.com/CmhXmT2.png",
    link: "https://createtoona.notion.site/Using-Katana-2a691ab9bdeb44db991eea064fea15d5",
    software: ["Photoshop"],
  },
  {
    title: "🐠Nigiri - Animate Panels!",
    description:
      "Nigiri is a tool that allows you to animate manga panels in After Effects. Nigiri integrates directly into After Effects, click the links below to download and learn more!",
    image: "https://i.imgur.com/Kt6Svnw.gif",
    link: "https://createtoona.notion.site/Using-Nigiri-9d044b486cc34b1c85816d1900afaf86",
    software: ["AfterEffects"],
  },
];

function Tools() {
  return (
    <div className="app-tools">
      <div className="tool-items">
        <h2>Tools</h2>
        {tools.map((tool, index) => {
          return (
            <div className="tool-card">
              <h3>{tool.title}</h3>
              <div className="flex-row">
                {tool.software.includes("Photoshop") && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 128 128"
                  >
                    <path
                      fill="#001e36"
                      d="M22.667 1.6h82.666C117.867 1.6 128 11.733 128 24.267v79.466c0 12.534-10.133 22.667-22.667 22.667H22.667C10.133 126.4 0 116.267 0 103.733V24.267C0 11.733 10.133 1.6 22.667 1.6"
                    />
                    <path
                      fill="#31a8ff"
                      d="M45.867 33.333c-1.6 0-3.2 0-4.853.054c-1.654.053-3.201.053-4.641.107c-1.44.053-2.773.053-4.053.106c-1.227.053-2.08.053-2.987.053c-.373 0-.533.213-.533.587v54.88c0 .48.213.694.64.694h10.347c.373-.054.64-.374.586-.747v-17.12c1.013 0 1.76 0 2.294.053c.533.053 1.386.053 2.666.053c4.374 0 8.374-.48 12-1.813c3.467-1.28 6.454-3.52 8.587-6.507c2.133-2.986 3.2-6.773 3.2-11.36c0-2.4-.426-4.693-1.226-6.933A16.98 16.98 0 0 0 64 39.36a19.049 19.049 0 0 0-7.147-4.374c-2.987-1.12-6.613-1.653-10.986-1.653m1.19 10.505c1.9.036 3.75.368 5.476 1.068c1.547.587 2.827 1.654 3.734 3.04a8.779 8.779 0 0 1 1.227 4.748c0 2.346-.534 4.16-1.654 5.493c-1.174 1.333-2.667 2.347-4.373 2.827c-1.974.64-4.054.959-6.134.959h-2.827c-.64 0-1.332-.053-2.079-.106v-17.92c.373-.054 1.12-.107 2.187-.053c1.013-.054 2.239-.054 3.626-.054c.273-.007.546-.008.817-.002m44.73 2.723c-3.787 0-6.934.586-9.44 1.866c-2.293 1.067-4.267 2.773-5.6 4.906c-1.173 1.974-1.814 4.16-1.814 6.454a11.447 11.447 0 0 0 1.227 5.44a13.809 13.809 0 0 0 4.054 4.533a32.629 32.629 0 0 0 7.573 3.84c2.613 1.013 4.373 1.813 5.227 2.506c.853.694 1.28 1.387 1.28 2.134c0 .96-.587 1.867-1.44 2.24c-.96.48-2.4.747-4.427.747c-2.133 0-4.267-.267-6.294-.8a22.834 22.834 0 0 1-6.613-2.613c-.16-.107-.32-.16-.48-.053c-.16.106-.213.319-.213.479v9.28c-.053.427.213.8.587 1.013a21.49 21.49 0 0 0 5.44 1.707c2.4.48 4.799.693 7.252.693c3.84 0 7.041-.586 9.654-1.706c2.4-.96 4.48-2.613 5.973-4.747a12.41 12.41 0 0 0 2.08-7.093a11.512 11.512 0 0 0-1.226-5.493c-1.014-1.814-2.454-3.307-4.214-4.427a38.625 38.625 0 0 0-8.213-3.894a48.784 48.784 0 0 1-3.787-1.76c-.693-.373-1.333-.853-1.813-1.44c-.32-.427-.533-.906-.533-1.386c0-.48.16-1.013.426-1.44c.374-.533.96-.907 1.653-1.067c1.014-.266 2.134-.427 3.2-.374c2.027 0 4 .267 5.974.694c1.814.373 3.52.96 5.12 1.814c.213.106.48.106.96 0a.656.656 0 0 0 .267-.534v-8.693c0-.214-.054-.427-.107-.64c-.107-.213-.32-.427-.533-.48A18.762 18.762 0 0 0 98.4 47.04a45.98 45.98 0 0 0-6.613-.48z"
                    />
                  </svg>
                )}
                {tool.software.includes("AfterEffects") && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 256 250"
                  >
                    <rect width="256" height="249.6" fill="#00005B" rx="42.5" />
                    <path
                      fill="#99F"
                      d="M102.843 149.333H63.172L55.1 174.454a2.02 2.02 0 0 1-1.901 1.547L32.947 176c-1.146 0-1.547-.63-1.202-1.89l34.347-98.509l.343-1.035l.114-.354l.23-.74c.114-.382.228-.787.343-1.226c.45-2.291.68-4.62.687-6.955a1.063 1.063 0 0 1 1.202-1.202h27.306c.8 0 1.257.286 1.374.859l38.983 109.335c.343 1.145 0 1.718-1.03 1.717h-22.326a1.587 1.587 0 0 1-1.717-1.202zm-33.488-21.181h27.134l-.387-1.277l-.621-2.022l-.909-2.896l-1.745-5.467l-1.662-5.254l-3.092-9.789a335.624 335.624 0 0 1-2.46-8.138l-.878-3.096l-.948-3.393l-.866-3.147h-.172a138.494 138.494 0 0 1-3.136 12.23l-1.16 3.723l-2.79 9l-1.414 4.585c-.256.828-.51 1.647-.765 2.456l-.76 2.398l-.756 2.342l-.752 2.284l-.748 2.227c-.372 1.1-.744 2.177-1.113 3.234m130.518 11.404h-33.831a24.126 24.126 0 0 0 3.263 9.461a17.669 17.669 0 0 0 7.813 6.44a32.629 32.629 0 0 0 13.653 2.676a61.87 61.87 0 0 0 11.077-1.216a40.825 40.825 0 0 0 9.523-2.482c.572-.456.86-.172.86.858v16.315c.028.445-.061.889-.259 1.288c-.196.312-.46.576-.772.773a43.673 43.673 0 0 1-10.64 3.17a75.478 75.478 0 0 1-15.113 1.287c-7.876 0-14.515-1.182-19.917-3.545l-.52-.233a36.423 36.423 0 0 1-13.394-10.132a39.677 39.677 0 0 1-7.385-13.996A55.127 55.127 0 0 1 142 134.678a54.141 54.141 0 0 1 2.662-16.916a44.186 44.186 0 0 1 7.985-14.597a38.361 38.361 0 0 1 12.88-10.133c5.037-2.46 10.991-3.343 17.86-3.343a38.757 38.757 0 0 1 16.573 3.263a29.208 29.208 0 0 1 11.248 8.495a39.057 39.057 0 0 1 6.354 12.107a43.145 43.145 0 0 1 2.061 13.052c0 2.52-.086 4.81-.257 6.87l-.153 1.764l-.16 1.674l-.095.848a33.26 33.26 0 0 1-.022.179a1.556 1.556 0 0 1-1.545 1.374l-.471.01l-.587.03l-.457.033l-1.068.091l-.938.093c-.255.027-.52.052-.795.075l-.851.067l-.909.06l-.965.05l-1.022.043l-.533.018l-1.107.03c-1.095.027-2.217-.041-3.368-.125l-1.746-.128a39.834 39.834 0 0 0-2.7-.106m-33.831-15.645h23.386l1.992-.013l1.354-.019l.877-.02l.984-.034a6 6 0 0 0 2.49-.825v-1.03a13.74 13.74 0 0 0-.686-3.95a14.03 14.03 0 0 0-13.91-9.79a14.918 14.918 0 0 0-14.169 8.072a24.842 24.842 0 0 0-2.318 7.61"
                    />
                  </svg>
                )}
              </div>
              <div className={"image-row"}>
                <img
                  src={tool.image}
                  className="preview-image"
                  alt="manga-masker"
                  height={200}
                  width={200}
                />
                <div className="flex-column">
                  <span>{tool.description}</span>
                  <div className="flex-row">
                    <a href="https://discord.gg/PheSgGaedc" title="upload-link">
                      <button className="upload-btn">Get it now!</button>
                    </a>
                    <a
                      href={tool.link}
                      className="guide-link"
                      title="upload-link"
                    >
                      <div className="link-row">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#5d5c5b"
                            d="M7.5 22q-1.45 0-2.475-1.025T4 18.5v-13q0-1.45 1.025-2.475T7.5 2H20v15q-.625 0-1.062.438T18.5 18.5q0 .625.438 1.063T20 20v2zm.5-7h2V4H8zm-.5 5h9.325q-.15-.35-.237-.712T16.5 18.5q0-.4.075-.775t.25-.725H7.5q-.65 0-1.075.438T6 18.5q0 .65.425 1.075T7.5 20"
                          />
                        </svg>
                        Learn More
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Tools;
